import React, {useState} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import ParentsBody from "./parentsBody";
import LoadingIndicator from "../../../common/loadingIndicator";

/**
 * Parents Component
 * @returns {JSX.Element}
 * @constructor
 */
const Parents = () => {
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [filters, setFilters] = useState({
        isLoading: false,
        isSubmitted: false,
    });

    return (
        <>
            <Breadcrumb title="Archive" parent="Commercial"/>
            <ParentsBody
                filters={filters}
                setFilters={setFilters}
                tableData={tableData}
                setTableData={setTableData}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
            />
            <LoadingIndicator isLoading={filters.isLoading}/>
        </>
    );
}

export default Parents;
